function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-offline",
  d: "M318,385.5H276a6,6,0,0,0-6,6v35a6,6,0,0,0,6,6h42a6,6,0,0,0,6-6v-35A6,6,0,0,0,318,385.5Zm-1,44H277a4,4,0,0,1-4-4v-33a4,4,0,0,1,4-4H317a4,4,0,0,1,4,4v33A4,4,0,0,1,317,429.51Zm-3.47,5h-32a1.5,1.5,0,0,0,0,3h32a1.5,1.5,0,0,0,0-3Z",
  transform: "translate(-270 -385.5)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2-offline"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1-offline",
  d: "M289,416l8,.94V410h-8Zm0-7h8v-6.94l-8,.94Zm9,8.06,8,.94v-8h-8Zm0-15.12V409h8v-8Z",
  transform: "translate(-270 -385.5)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-offline",
  d: "M278.5,440.88h37a8,8,0,0,1,0,16h-37a8,8,0,0,1,0-16Z",
  transform: "translate(-270 -385.5)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M288.55,449.47a4.4,4.4,0,0,1-.35,1.82,2.67,2.67,0,0,1-1,1.19,2.75,2.75,0,0,1-4-1.18,4.21,4.21,0,0,1-.37-1.77V449a4.35,4.35,0,0,1,.36-1.81,2.64,2.64,0,0,1,2.5-1.62,2.76,2.76,0,0,1,1.51.41,2.66,2.66,0,0,1,1,1.2,4.42,4.42,0,0,1,.35,1.82Zm-.93-.46a3.18,3.18,0,0,0-.51-1.94,1.68,1.68,0,0,0-1.42-.68,1.66,1.66,0,0,0-1.4.68,3.12,3.12,0,0,0-.52,1.88v.52a3.2,3.2,0,0,0,.51,1.93,1.81,1.81,0,0,0,2.83,0,3.18,3.18,0,0,0,.51-1.9Z",
  transform: "translate(-270 -385.5)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M290.26,452.8v-4.58h-.83v-.7h.83V447a1.8,1.8,0,0,1,.45-1.31,1.72,1.72,0,0,1,1.28-.46,2.36,2.36,0,0,1,.62.08l0,.73a2.59,2.59,0,0,0-.49,0,.88.88,0,0,0-.68.26,1,1,0,0,0-.24.74v.56h1.13v.7h-1.13v4.58Z",
  transform: "translate(-270 -385.5)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M293.73,452.8v-4.58h-.83v-.7h.83V447a1.8,1.8,0,0,1,.45-1.31,1.72,1.72,0,0,1,1.28-.46,2.36,2.36,0,0,1,.62.08l0,.73a2.59,2.59,0,0,0-.49,0,.88.88,0,0,0-.68.26,1,1,0,0,0-.24.74v.56h1.13v.7h-1.13v4.58Z",
  transform: "translate(-270 -385.5)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M297.74,452.8h-.9v-7.5h.9Z",
  transform: "translate(-270 -385.5)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M299.19,446.11a.54.54,0,0,1,.13-.37.51.51,0,0,1,.4-.15.51.51,0,0,1,.4.15.54.54,0,0,1,.14.37.56.56,0,0,1-.94.37A.52.52,0,0,1,299.19,446.11Zm1,6.68h-.9v-5.28h.9Z",
  transform: "translate(-270 -385.5)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M302.47,447.51l0,.66a1.92,1.92,0,0,1,1.58-.76q1.67,0,1.69,1.89v3.49h-.9v-3.5a1.21,1.21,0,0,0-.26-.84,1,1,0,0,0-.8-.27,1.3,1.3,0,0,0-.77.23,1.59,1.59,0,0,0-.52.62v3.76h-.9v-5.28Z",
  transform: "translate(-270 -385.5)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-offline",
  d: "M309.32,452.89a2.31,2.31,0,0,1-1.75-.71,2.62,2.62,0,0,1-.67-1.89v-.17a3.18,3.18,0,0,1,.3-1.4,2.35,2.35,0,0,1,.84-1,2.11,2.11,0,0,1,1.17-.35,2,2,0,0,1,1.6.68,2.94,2.94,0,0,1,.57,1.94v.38H307.8a1.87,1.87,0,0,0,.46,1.26,1.43,1.43,0,0,0,1.11.48,1.57,1.57,0,0,0,.81-.2,2,2,0,0,0,.58-.52l.55.43A2.22,2.22,0,0,1,309.32,452.89Zm-.11-4.74a1.2,1.2,0,0,0-.92.4,1.93,1.93,0,0,0-.46,1.12h2.65v-.07a1.72,1.72,0,0,0-.37-1.07A1.13,1.13,0,0,0,309.21,448.16Z",
  transform: "translate(-270 -385.5)"
});

var SvgSafeOffline = function SvgSafeOffline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "offline_computer",
    "data-name": "Layer 1",
    viewBox: "0 0 54 71.38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafeOffline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safe_offline.53a91293.svg";
export { ForwardRef as ReactComponent };